import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=1c803acd&"
import script from "./FlipCard.vue?vue&type=script&lang=js&"
export * from "./FlipCard.vue?vue&type=script&lang=js&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c803acd')) {
      api.createRecord('1c803acd', component.options)
    } else {
      api.reload('1c803acd', component.options)
    }
    module.hot.accept("./FlipCard.vue?vue&type=template&id=1c803acd&", function () {
      api.rerender('1c803acd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FlipCard.vue"
export default component.exports